import { ProfileStat, ProfileStatData } from "src/models/ProfileStats";

const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export class DemoData {
  public static generate(start: Date, end: Date, max: number): ProfileStat {
    const curDate = new Date(start.getTime());
    const myStat = {
      slug: "demo",
      rows: [],
    } as ProfileStat;
    while (curDate.getTime() < end.getTime()) {
      myStat.rows.push({
        week: `${monthNames[curDate.getMonth()]} ${curDate.getDate()}`,
        value: Math.floor(Math.random() * max),
      } as ProfileStatData);
      curDate.setDate(curDate.getDate() + 1 * 7);
    }
    return myStat;
  }
}
